import {ALL_SOURCES} from 'src/modules/user-settings/constants';
import {TreeItem} from 'src/modules/user-settings/typedefs';
import {createTreeItemId} from 'src/modules/user-settings/utils/createTreeItemId';

const SELECT_ALL_EVENTS = 'Select All Events';

const createFamilyNode = (
    source: string,
    family: string,
    disabled: boolean,
): TreeItem => ({
    id: createTreeItemId(source, family),
    caption: family,
    disabled,
});

export const createTree = (
    sourcesList: string[],
    familiesList: string[],
    disabled: boolean,
): TreeItem[] => {
    const sourcesWithFamilies = sourcesList.map(source => ({
        id: source,
        caption: source,
        disabled,
        children: [...familiesList.map(family => (createFamilyNode(source, family, disabled)))],
    }));

    return [{
        id: ALL_SOURCES,
        caption: SELECT_ALL_EVENTS,
        children: sourcesWithFamilies,
        expanded: true,
        disabled,
    }];
};
